import store from "../../stores";

export function requireSC(to, from, next) {
    console.log('guard', 'requireSC', from.name, to.name);
    const unwatch = store.watch((state, getters) => getters['shoppingCart/loading'], () => {
        if (store.getters["shoppingCart/loading"] === true) {
            return;
        }
        if (store.getters["shoppingCart/cartCount"] > 0) {
            if (typeof unwatch === 'function') unwatch();
            next();
            return;
        }
        if (typeof unwatch === 'function') unwatch();
        next({name: 'places'});
    });
    if (store.getters["shoppingCart/loading"]) {
        return;
    }
    if (store.getters["shoppingCart/cartCount"] > 0) {
        next();
        return;
    }
}



// WEBPACK FOOTER //
// ./src/router/guards/require-shopping-cart.guard.js